/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AssetsInputs */

const en_assets = /** @type {(inputs: AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_assets = /** @type {(inputs: AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activos`)
};

const fr_assets = /** @type {(inputs: AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biens`)
};

const de_assets = /** @type {(inputs: AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const id_assets = /** @type {(inputs: AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset`)
};

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const ja_assets = en_assets;

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const zh_assets = en_assets;

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const ar_assets = en_assets;

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const it_assets = en_assets;

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const ru_assets = en_assets;

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const pt_assets = en_assets;

/** @type {(inputs: AssetsInputs) => LocalizedString} */
const ko_assets = en_assets;

/**
* | output |
* | --- |
* | "Assets" |
*
* @param {AssetsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const assets = /** @type {((inputs?: AssetsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AssetsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assets(inputs)
	if (locale === "es") return es_assets(inputs)
	if (locale === "fr") return fr_assets(inputs)
	if (locale === "de") return de_assets(inputs)
	if (locale === "ja") return ja_assets(inputs)
	if (locale === "zh") return zh_assets(inputs)
	if (locale === "ar") return ar_assets(inputs)
	if (locale === "id") return id_assets(inputs)
	if (locale === "it") return it_assets(inputs)
	if (locale === "ru") return ru_assets(inputs)
	if (locale === "pt") return pt_assets(inputs)
	return ko_assets(inputs)
});